import { createDebug } from '@danone-global/internal/react/core'

export default createDebug('deeplink')
